import axiosInstance from '../helpers/axios';
import { handleError, handleInfo, handleSuccess } from '../helpers/utils';

const endpointExcel =
	'https://desarrollo-web-323816.uc.r.appspot.com/api/excel/download-excel';

export const generateSimpleExcel = async (payload, filename) => {
	handleInfo('Generando Excel...', 6);

	return await axiosInstance({
		url: endpointExcel,
		method: 'POST',
		responseType: 'blob',
		data: { data: payload },
	})
		.then((response) => {
			try {
				// URL
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);

				// Create link
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${filename}.xlsx`);

				// Set link
				document.body.appendChild(link);
				link.click();
				handleSuccess('Reporte generado');
			} catch (error) {
				handleError(
					error,
					'Hubo un error al crear el archivo de excel. [1]'
				);
			}
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear crear el archivo de excel. [2]'
			);
		});
};
